//
import axios from 'axios';

//
const apiClient = axios.create({
    baseURL: '/',
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
    withCredentials: true,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: Infinity,
});

// apiClient.interceptors.request.use(
//     (config) => {
//         const token = localStorage.getItem('token');
//         if (token) {
//             config.headers.Authorization = `Bearer ${token}`;
//         }
//         return config;
//     },
//     (error) => Promise.reject(error)
// );

//
apiClient.interceptors.response.use(
    (response) => response.data, // 直接取出 data 層
    (error) => {
        // 統一錯誤格式
        if (axios.isAxiosError(error)) {
            const formattedError = {
                status: error.response?.status || 500,
                message:
                    error.response?.data?.message ||
                    error.message ||
                    'Unknown error',
                data: error.response?.data || null,
            };
            return Promise.reject(formattedError);
        }
        return Promise.reject({
            status: 500,
            message: 'Unexpected error',
            data: null,
        });
    }
);

export default apiClient;
